import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const MobilniZarizeni = {
	name: NAME,
	apiProvider,
	router,
};
